import { environment } from "../../../../environments/environment";

export const Panels: any[] = [
    {
      name: 'Panel Stadium',
      location: {
        address: 'Av. Libertadores',
        coords: {
          lat: '-17.37966268783538',
          lng: '-66.16064659825375'
        }
      },
      photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web.webp?alt=media&token=117c5c2f-f09c-4bd1-bce7-2785a10f11c1',
      link: `${environment.baseLink}/resume-panel/`,
      id: 'd4bc647d-60d5-4765-9ada-e8b5ec8a623d'
    },
    {
      name: 'Panel Aeropuerto',
      location: {
        address: 'Salida Aeropuerto Jorge Wilstermann',
        coords: {
          lat: '-17.411050550945493',
          lng: '-66.1749173316861'
        }
      },
      photo: '',
      link: `${environment.baseLink}/resume-panel/`,
      id: '1d52f90b-44da-4ee7-b46a-28ff70c8be0a'
    }
]